import { Component, OnInit, Input } from '@angular/core';
import { FilesService } from '../../../services/files.service';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { StationService } from '../../../services/stations.service';

@Component({
  selector: 'ngx-sassisopa',
  templateUrl: './sassisopa.component.html',
  styleUrls: ['./sassisopa.component.scss'],
})
export class SassisopaComponent implements OnInit {
  files: Array<any> = [];
  file_type: string = 'procedimientos';
  loading: boolean = false;
  stationId: string;
  downloading = false;
  dataLoaded = false;

  constructor(
    private fileService: FilesService,
    private router: Router,
    private route: ActivatedRoute,
    private stationService: StationService
  ) {
    this.route.params
      .subscribe(params => {
        this.stationId = params['stationId'];
        this.stationService.setActiveStation(params['stationId'])
      });
    this.stationService.change.subscribe(async (station: any) => {
      if (this.dataLoaded) return 0;
      this.router.navigateByUrl(this.router.url.replace(this.stationId, station));
      this.stationId = station;
      this.getFiles();
      this.dataLoaded = true;
    });
  }

  ngOnInit() {
    this.stationService.checkIfStationIdOrRefirect();
    this.getFiles();
  }

  async getFiles() {
    this.files = [];
    this.loading = true;
    const [error, { data: files }] = await this.fileService.getFiles('sasisopa', this.file_type);
    this.loading = false;
    if (error) return error;
    files.forEach((file) => {
      this.files.push({ ...file, downloading: false });
    });
  }

  async generateDocument(file) {
    // tslint:disable-next-line: max-line-length
    return `${environment.baseEndpoint}/filesGeneratorv2/${this.stationId}?procedure=sasisopa&documentType=${this.file_type}&document=${file}`;
  }

  async downloadFile(file) {
    file.downloading = true;
    const generateFile = await this.generateDocument(file.file);
    await this.fileService.downloadFile(generateFile);
    console.error(generateFile);
    file.downloading = false;
  }
}